<template>
    <div>

        <remote-playback v-if="isStreamingHardware" v-model="isRemotePlaybackModal" :vehicle-uuid="vehicleId" :is-hardware-online="isHardwareOnline" :active-device="deviceDetails" @calendar-processed="calendarProcessed"></remote-playback>
    </div>

</template>

<script>
import SpButton from "@/components/forms/Button";
import RemotePlayback from "@/views/Journeys/RemotePlayback";

export default {
    name: 'RemotePlaybackDialog',
    components: {
        RemotePlayback
    },
    data () {
        return {
            isRemotePlaybackModal: false,
            remotePlaybackPreviewButtonText: 'Remote playback',
            remotePlaybackTimeout: null,
            dialogRequestVideo: false,
            videoLengths: [
                {
                    key: '10',
                    text: '10 seconds'
                },
                {
                    key: '15',
                    text: '15 seconds'
                },
                {
                    key: '20',
                    text: '20 seconds'
                },
                {
                    key: '30',
                    text: '30 seconds'
                },
                {
                    key: '45',
                    text: '45 seconds'
                },
                {
                    key: '60',
                    text: '60 seconds'
                }
            ],
            dialogRequestVideoData: {
                videoLength: '10',
                videoLengthMask: '###',
                created: null
            },
        }
    },
    props: {
        isStreamingHardware: {
            type: Boolean,
            required: true,
        },
        isHardwareOnline: {
            type: Boolean,
            required: true,
        },
        deviceDetails: {
            type: Object,
            required: true,
        },
        vehicleId: {
            type: String,
            required: true
        },
    },
    methods: {
        calendarProcessed () {

        }
    }
}
</script>

<style scoped>

</style>
